import { render } from "./SubLinkNave.vue?vue&type=template&id=64a7f39f&scoped=true"
import script from "./SubLinkNave.vue?vue&type=script&lang=js"
export * from "./SubLinkNave.vue?vue&type=script&lang=js"

import "./SubLinkNave.vue?vue&type=style&index=0&id=64a7f39f&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a7f39f"]])

export default __exports__